import React, {useState, useEffect, useContext} from "react";
import { AppContext } from "../../App.js";
import { NavLink, Link } from 'react-router-dom';

//Import Css
import './panelMenuSlideDV.css';

//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'

export function PanelMenuSlideDV({activeMenu}) {


    const {

        //Panel Menu Slide Dv
        openMenuSlideDv,
        setOpenMenuSlideDv,
        valorScreenDv,
        setValorScreenDv

    } = useContext(AppContext);


    return(


         /* --------- PANEL MENU MOBILE SLIDE DV ----------- */
        <div className={`style-panel-menu-slide-dv panel-menu-slide-dv-${openMenuSlideDv ? 'open' : 'close'}`}>


            <button className="btn-menu-slide-dv" onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}>
                
                    <span id='btn-slide-menu-close-dv' className="material-symbols-outlined">close</span>

            </button>

            <div className='container-nenu-slide-dv'>

                <div className="box-logo-panel-slide-dv">

                        <img className='logo-webmedia-panel-slide-dv' src={LogoWebmedia} alt="Logo WebMedia"/>

                </div>

                <nav className="links-panel-slide-dv">

                    <NavLink to='/'                      className={`menu-link-dv link-dv-1 ${activeMenu === 'inicio' ? 'activeMenu' : ''}`}>Inicio</NavLink>
                    <NavLink to='/desarrollo-web'        className={`menu-link-dv link-dv-2 ${activeMenu === 'desarrollo-web' ? 'activeMenu' : ''}`}>Desarrollo Web</NavLink>
                    <NavLink to='/google-ads'            className={`menu-link-dv link-dv-3 ${activeMenu === 'google-ads' ? 'activeMenu' : ''}`}>Google ADS</NavLink>
                    <NavLink to='/email-marketing'       className={`menu-link-dv link-dv-4 ${activeMenu === 'email-marketing' ? 'activeMenu' : ''}`}>Email Marketing</NavLink>
                    <NavLink to='/soporte-empresas'      className={`menu-link-dv link-dv-5 ${activeMenu === 'soporte-empresas' ? 'activeMenu' : ''}`}>Soporte Empresas</NavLink>
                    <NavLink to='/contacto'              className={`menu-link-dv link-dv-6 ${activeMenu === 'contacto' ? 'activeMenu' : ''}`}>Contacto   </NavLink>

                </nav>

            </div>

        </div>


    );
}